import md5 from 'md5'
const SIGNKEY = 'sjdxfnqogbzoun13d971ckh8p'
import store from '@/store/index.js'

export function getSignHeader (param, isJsonContent) {
  let headers = {}
  let paramValStr = ''
  let timestamp = new Date().getTime()
  if (param && typeof param === 'object') {
    if (isJsonContent) {
      paramValStr = JSON.stringify(param)
    } else {
      Object.keys(param).sort().forEach((item) => {
        paramValStr += param[item]
      })
    }
  }
  let signature = md5(`${SIGNKEY}${paramValStr}${timestamp}`)
  headers.signature = signature
  headers.timestamp = timestamp
  headers.appcode = store.state.serviceConfig.appCode || ''
  return headers
}
